import type { DialogProps } from "../misc/DialogProps";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { DialogCloseButton } from "../misc/DialogCloseButton";
import { InstructorInAppNotificationsList } from "../details/instructor/InstructorInAppNotificationsList";

export function InAppNotificationsDialog(props: DialogProps) {
  return (
    <Dialog {...props} maxWidth="sm" fullWidth>
      <DialogTitle>In-App-Benachrichtigungen</DialogTitle>
      <DialogCloseButton onClick={props.onClose} />
      <DialogContent sx={{ minHeight: 400 }}>
        <InstructorInAppNotificationsList />
      </DialogContent>
    </Dialog>
  );
}
